import report from './report';

const stlntChild = [
    // To be determine if it is on admin or partner profile
    // channel,
    report
];

export default stlntChild;
